/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				if(buttonContext === 'service'){
					this.deselectActiveNode();

					return this.performAction(
						this.prepareAction(baseActionKey)
					);
				}
				else if(buttonContext === 'assignedService'){
					var nodeData = this.getSelectedNodeData();
					this.deselectActiveNode();

					return this.performAction(
						this.prepareAction(baseActionKey, undefined, undefined, {
							source: {
								load: {
									componentData: {
										actions: {
											loadContent: {
												source: {
													load: {
														componentData: {
															model: {
																dirtyFields: {
																	data: {
																		attributes: {
																			serviceID: nodeData.serviceID
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						})
					);
				}
			}

			return utils.promise.reject();
		},
		showEdit: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var options = (additionalData || {}).options || {};
			var serviceID = (options.nodeData || {})._primaryKey || this.getSelectedNodeID();
			if(this.actions[baseActionKey] && !utils.isEmpty(serviceID)){
				return this.performAndStoreAction(
					options.actionKey,
					this.prepareAction(baseActionKey, serviceID, { serviceID: serviceID }, {
						refreshPersistent:  false,
					}),
					true
				);
			}

			return utils.promise.reject();
		},
		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();
			if(this.actions[baseActionKey] && nodeData._primaryKey){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey, undefined, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		authDomain: '',
																		url: '',
																		name: '',
																		databaseID: null
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					})
				);
			}

			return utils.promise.reject();
		},
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeID = self.getSelectedNodeID();
					self.deselectActiveNode();
					if(self.actions[baseActionKey] && !utils.isEmpty(nodeID)){
						self.setClosestNodeAsReady(nodeIndex);

						return self.performAction(
							self.prepareAction(baseActionKey, nodeID)
						).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Services...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var index, additionalClasses;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();

				utils.forEach(this.resourceData.data, function (serviceData) {
					resources.initialized = true;

					if(serviceData.attributes) {
						var service = serviceData.attributes;
						var primaryKey = service[serviceData.primaryKey];
						var parent = '#';

						index = self.transformIDToIndex(primaryKey, 'service', 0, tree.length);

						additionalClasses = ''
						if(service.status === 'inactive'){
							additionalClasses = 'state_inactive'
						} else if(service.status === 'locked'){
							additionalClasses = 'state_preview'
						}

						tree.push({
							id: index,
							parent: parent,
							text: `${service.name} [#${primaryKey} - ${service.applicationType}]`,
							type: 'service',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {
								class: additionalClasses
							}
						});
						service._primaryKey = primaryKey;
						nodes[index] = service;

						if(serviceData.children && serviceData.children.assignedServices && serviceData.children.assignedServices.data){
							var assignedServiceIndex, assignedService, assignedServicePrimaryKey, assignedServiceCore, assignedServiceName;
							utils.forEach(serviceData.children.assignedServices.data, function (assignedServiceData) {
								assignedService = assignedServiceData.attributes;
								assignedServicePrimaryKey = assignedService[assignedServiceData.primaryKey];
								assignedServiceIndex = self.transformIDToIndex(assignedServicePrimaryKey, 'assignedService', 0, tree.length);
								if(assignedServiceData.children && assignedServiceData.children.s_services && assignedServiceData.children.s_services.data && assignedServiceData.children.s_services.data.attributes){
									assignedServiceCore = assignedServiceData.children.s_services.data.attributes || {};
								}

								let additionalClasses = ''
								if(assignedService.status === 'inactive'){
									additionalClasses = 'state_inactive'
								} else if(
									assignedService.status === 'locked' ||
									assignedServiceCore.status === 'inactive' ||
									assignedServiceCore.status === 'locked'
								){
									additionalClasses = 'state_preview'
								}

								tree.push({
									id: assignedServiceIndex,
									parent: index,
									text: `${assignedServiceCore.name || ''} @ ${assignedService.code} [#${assignedServiceCore.serviceID} - ${assignedServiceCore.applicationType}]`,
									type: 'assignedService',
									state: {
										opened: true,
										disabled: false,
										selected: false
									},
									li_attr: {},
									a_attr: {
										class: additionalClasses
									}
								});
								assignedService._primaryKey = assignedServicePrimaryKey;
								nodes[assignedServiceIndex] = assignedService;
							});
						}
					}
				});

				this.resourceData = resources;
			}
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.serviceTreesActions';
					if(data.onTreeActionOptions.eventData.node.type === 'assignedService')  selector = '.serviceTreesAssignedServiceActions';
					this.$.find(selector).show();
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			if(options){
				if(options.decisionType === 'submit'){
					if(options.decisionComponent.hasClass('base_modal_modal')){
						const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
						if(
							modalContentComponent
							&&
							(
								modalContentComponent.hasClass('templates_propertiesForms_servicePropertiesForm')
								||
								modalContentComponent.hasClass('templates_propertiesForms_assignedServicePropertiesForm')
							)
						){
							await modalContentComponent.submit()
                            await options.decisionComponent.hide()
						}
					}
				}
				else if(options.decisionType === 'cancel' && options.decisionComponent.hasClass('base_modal_modal')){
					await options.decisionComponent.hide()
				}
			}
		}
	},



	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_servicePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_servicePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'service';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_assignedServicePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_assignedServicePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'assignedService';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
